var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['ini-btn', 'btn', 'btn-'+_vm.type, {'btn--icon-text' : _vm.icon }],attrs:{"type":"button"},on:{"click":_vm.buttonClicked}},[(_vm.icon)?_c('i',{class:'zmdi zmdi-'+_vm.icon}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }